import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import queryString from "query-string";
PouchDB.plugin(PouchdbFind);

export default class NovoUsuario1 extends Component {
  constructor(props) {
    super(props);
    this.loadEmpresas = this.loadEmpresas.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.cadastrar = this.cadastrar.bind(this);
    this.validarCadastro = this.validarCadastro.bind(this);
    this.getDefaultUsuario = this.getDefaultUsuario.bind(this);
    this.handleChangeVendedor = this.handleChangeVendedor.bind(this);
    this.loadPerfis = this.loadPerfis.bind(this);
    this.handleChangePerfil = this.handleChangePerfil.bind(this);
    this.buscarUsuario = this.buscarUsuario.bind(this);

    this.state = {
      _id: null,
      action: "CADASTRAR", //CADASTRAR EDITAR,
      usuario: this.getDefaultUsuario(),
      errors: {
        desc: false,
        login: false,
        senha: false,
        senhaRepetir: false,
        email: false,
        celular: false,
        cargo: false,
        vendedores: [],
        perfil: false,
      },
      empresas: [],
      vendedoresSelecionados: [],
      perfis: [],
      idPerfilSelecionado: "0",
      empresasUsuarioEditar: [],
    };
  }

  async componentDidMount() {
    let id = queryString.parse(this.props.location.search).id;
    if (id === undefined) {
      id = null;
    }

    let action = "CADASTRAR";

    if (id !== null) {
      action = "EDITAR";
    }

    this.setState({ action, _id: id }, async () => {
      if (this.state.action === "CADASTRAR") {
        await this.loadEmpresas();
        await this.loadPerfis();
      } else {
        await this.buscarUsuario(id);
      }

      await this.loadPerfis();
    });
  }

  async loadEmpresas() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/usuarios-novo/empresas-vendedores`,
        this.props.parameters()
      )
      .then((response) => {
        let empresas = response.data.empresas;

        this.setState(
          {
            empresas,
          },
          () => {
            let vendedoresSelecionados = this.state.vendedoresSelecionados;
            let errors = this.state.errors;
            let i = 0;

            for (let empresa of empresas) {
              vendedoresSelecionados[i] = {
                idIntegracaoEmpresa: empresa.idIntegracao,
                idIntegracaoVendedor: null,
              };
              errors.vendedores[i] = false;
              i++;
            }

            this.setState({ vendedoresSelecionados });
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }
  async buscarUsuario(id) {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/usuarios-novo/${id}`,
        this.props.parameters()
      )
      .then((response) => {
        let usuario = response.data.usuario;
        let empresas = usuario.empresas;
        usuario.senha = "";
        usuario.senhaRepetir = "";

        this.setState({ empresasUsuarioEditar: empresas, usuario }, () => {
          this.loadPerfis();
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  getDefaultUsuario() {
    return {
      desc: "",
      login: "",
      senha: "",
      senhaRepetir: "",
      email: "",
      celular: "",
      cargo: "",
    };
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleChangeInput(value, tipo) {
    let usuario = this.state.usuario;
    usuario[tipo] = value;
    this.setState({ usuario });
  }

  handleChangePerfil(value) {
    this.setState({ idPerfilSelecionado: value });
  }

  async cadastrar() {
    if (!this.validarCadastro()) {
      this.notificar("warning", "Preencha todos os campos!");
      return false;
    }

    if (this.state.usuario.senha !== this.state.usuario.senhaRepetir) {
      this.notificar("warning", "As senhas não correspondem");
      return false;
    }

    if (this.state.action === "CADASTRAR") {
      if (
        this.state.vendedoresSelecionados.filter(
          (it) => it.idIntegracaoVendedor !== null
        ).length === 0
      ) {
        this.notificar("warning", "Favor selecionar pelo menos 1 vendedor!");
        return false;
      }
    }

    let usuario = this.state.usuario;
    usuario.perfil = this.state.perfis.find(
      (it) => it._id === this.state.idPerfilSelecionado
    );

    let data = {
      usuario: this.state.usuario,
      vendedoresSelecionados: this.state.vendedoresSelecionados,
    };

    let urlApi = `${this.props.getBaseUrlApi()}/usuarios-novo`;
    if (this.state.action === "EDITAR") {
      urlApi = `${urlApi}/${this.state._id}`;
    }

    await axios
      .post(urlApi, data, this.props.parameters())
      .then((response) => {
        this.notificar(
          "success",
          `Usuário ${
            this.state.action === "CADASTRAR" ? "cadastrado" : "editado"
          } com sucesso!`
        );
        setTimeout(() => {
          this.props.history.push("/usuarios");
        }, 1500);
      })
      .catch((error) => {
        console.log(error);
        this.notificar("warning", error.response.data.erro);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  validarCadastro() {
    let errorsLocal = this.state.errors;
    let valido = true;

    if (this.state.usuario.desc === "") {
      errorsLocal.desc = true;
      valido = false;
    } else {
      errorsLocal.desc = false;
    }

    if (this.state.usuario.login === "") {
      errorsLocal.login = true;
      valido = false;
    } else {
      errorsLocal.login = false;
    }

    if (this.state.action === "CADASTRAR") {
      if (this.state.usuario.senha === "") {
        errorsLocal.senha = true;
        valido = false;
      } else {
        errorsLocal.senha = false;
      }

      if (this.state.usuario.senhaRepetir === "") {
        errorsLocal.senhaRepetir = true;
        valido = false;
      } else {
        errorsLocal.senhaRepetir = false;
      }
    }

    if (this.state.usuario.email === "") {
      errorsLocal.email = true;
      valido = false;
    } else {
      errorsLocal.email = false;
    }

    if (this.state.usuario.celular === "") {
      errorsLocal.celular = true;
      valido = false;
    } else {
      errorsLocal.celular = false;
    }

    if (this.state.usuario.cargo === "") {
      errorsLocal.cargo = true;
      valido = false;
    } else {
      errorsLocal.cargo = false;
    }

    for (let i = 0; i < errorsLocal.vendedores.length; i++) {
      if (this.state.vendedoresSelecionados[i].idIntegracaoVendedor === null) {
        //    errorsLocal.vendedores[i] = true;
        //  valido = false;
      } else {
        errorsLocal.vendedores[i] = false;
      }
    }

    if (this.state.idPerfilSelecionado === "0") {
      errorsLocal.perfil = true;
      valido = false;
    } else {
      errorsLocal.perfil = false;
    }

    this.setState({ errors: errorsLocal });
    return valido;
  }

  handleChangeVendedor(value, idIntegracaoEmpresa) {
    if (value === "null") value = null;
    let vendedoresSelecionados = this.state.vendedoresSelecionados;

    for (let vendedorSelecionado of vendedoresSelecionados) {
      if (vendedorSelecionado.idIntegracaoEmpresa === idIntegracaoEmpresa) {
        vendedorSelecionado.idIntegracaoVendedor = parseInt(value);
      }
    }

    this.setState({ vendedoresSelecionados });
  }

  async loadPerfis() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/usuarios-novo/lista-perfis`,
        this.props.parameters()
      )
      .then((response) => {
        let perfis = response.data.perfis;
        let idPerfilSelecionado = this.state.idPerfilSelecionado;

        if (this.state.action === "EDITAR") {
          idPerfilSelecionado = perfis.find(
            (it) => it._id === this.state.usuario.perfil._id
          )._id;
        }

        this.setState({ perfis, idPerfilSelecionado });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={`${
              this.state.action === "CADASTRAR" ? "Novo" : "Editar"
            } Usuário`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"usuarios-novo"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className=""
                                  style={{
                                    float: "left",
                                    width: "100%",
                                  }}
                                >
                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Descrição</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.desc
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.desc}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "desc"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Login</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.login
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.login}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "login"
                                            )
                                          }
                                          disabled={
                                            this.state.action === "EDITAR"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Senha</label>
                                        <input
                                          type="password"
                                          className={`form-control ${
                                            this.state.errors.senha
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.senha}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "senha"
                                            )
                                          }
                                        />
                                        {this.state.action === "EDITAR" && (
                                          <small>
                                            Somente informe a senha se desejar
                                            alterar.
                                          </small>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Repetir Senha</label>
                                        <input
                                          type="password"
                                          className={`form-control ${
                                            this.state.errors.senhaRepetir
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={
                                            this.state.usuario.senhaRepetir
                                          }
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "senhaRepetir"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Email</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.email
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.email}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "email"
                                            )
                                          }
                                          disabled={
                                            this.state.action === "EDITAR"
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Celular</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.celular
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.celular}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "celular"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-wrap w-100 float-left">
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Cargo</label>
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            this.state.errors.cargo
                                              ? "input-error"
                                              : ""
                                          }`}
                                          value={this.state.usuario.cargo}
                                          onChange={(e) =>
                                            this.handleChangeInput(
                                              e.target.value,
                                              "cargo"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-6 no-padding padding-novo-usuario">
                                      <div className="form-group">
                                        <label>Perfil de Acesso</label>

                                        <select
                                          className={`form-control ${
                                            this.state.errors.perfil
                                              ? "input-error"
                                              : ""
                                          }`}
                                          style={{
                                            border: "1px solid #ced4da",
                                          }}
                                          value={this.state.idPerfilSelecionado}
                                          onChange={(e) =>
                                            this.handleChangePerfil(
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="0">Selecione</option>
                                          {this.state.perfis.map((perfil) => (
                                            <option value={perfil._id}>
                                              {perfil.desc}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.action === "CADASTRAR" && (
                                    <React.Fragment>
                                      {this.state.vendedoresSelecionados
                                        .length > 0 &&
                                        this.state.empresas.map(
                                          (empresa, key) => (
                                            <div
                                              className="form-group"
                                              key={key}
                                            >
                                              <label>
                                                {empresa.idIntegracao} -{" "}
                                                {empresa.fantasia}
                                              </label>
                                              <select
                                                value={
                                                  this.state
                                                    .vendedoresSelecionados[key]
                                                    .idIntegracaoVendedor
                                                }
                                                onChange={(e) =>
                                                  this.handleChangeVendedor(
                                                    e.target.value,
                                                    empresa.idIntegracao
                                                  )
                                                }
                                                className={`form-control ${
                                                  this.state.errors.vendedores[
                                                    key
                                                  ]
                                                    ? "input-error"
                                                    : ""
                                                }`}
                                              >
                                                <option value={"null"}>
                                                  Escolher vendedor
                                                </option>
                                                {empresa.vendedores.map(
                                                  (vendedor, key) => (
                                                    <option
                                                      value={
                                                        vendedor.idIntegracao
                                                      }
                                                      key={key}
                                                    >
                                                      {vendedor.desc}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </div>
                                          )
                                        )}
                                    </React.Fragment>
                                  )}

                                  {this.state.action === "EDITAR" && (
                                    <React.Fragment>
                                      {this.state.empresasUsuarioEditar.length >
                                        0 &&
                                        this.state.empresasUsuarioEditar.map(
                                          (empresa, key) => (
                                            <div
                                              className="form-group"
                                              key={key}
                                            >
                                              <label>
                                                {empresa.idIntegracao} -{" "}
                                                {empresa.fantasia}
                                              </label>
                                              <select
                                                value={"1"}
                                                className={`form-control`}
                                                disabled={true}
                                              >
                                                <option value={"1"}>
                                                  {empresa.descVendedor}
                                                </option>
                                              </select>
                                            </div>
                                          )
                                        )}
                                    </React.Fragment>
                                  )}

                                  <div className="form-group">
                                    <button
                                      className="btn btn-success"
                                      onClick={this.cadastrar}
                                    >
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>
                                      &nbsp;{" "}
                                      {this.state.action === "CADASTRAR"
                                        ? "Salvar"
                                        : "Editar"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
